<label class="visually-hidden" for="product-type-filter">
  {{ 'general.type' | translate }}
</label>
<nz-select
  nzId="product-type-filter"
  [nzPlaceHolder]="'general.type' | translate"
  nzAllowClear
  [nzShowArrow]="true"
  [ngModel]="(selected$ | async) || null"
  (ngModelChange)="saveSelected($event)"
>
  @for (option of options$ | async; track option.id) {
    <nz-option
      [nzLabel]="option.name | translate"
      [nzValue]="option.id"
    ></nz-option>
  }
</nz-select>
